import c from "./ghl-ui.es1143.js";
import b from "./ghl-ui.es1120.js";
const g = (i) => {
  const d = "rgba(0, 0, 0, .85)", e = "0 2px 8px 0 rgba(0, 0, 0, 0.12)", {
    railColor: o,
    primaryColor: r,
    baseColor: l,
    cardColor: t,
    modalColor: n,
    popoverColor: s,
    borderRadius: x,
    fontSize: a,
    opacityDisabled: p
  } = i;
  return Object.assign(Object.assign({}, c), {
    fontSize: a,
    markFontSize: a,
    railColor: o,
    railColorHover: o,
    fillColor: r,
    fillColorHover: r,
    opacityDisabled: p,
    handleColor: "#FFF",
    dotColor: t,
    dotColorModal: n,
    dotColorPopover: s,
    handleBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowHover: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowActive: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowFocus: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    indicatorColor: d,
    indicatorBoxShadow: e,
    indicatorTextColor: l,
    indicatorBorderRadius: x,
    dotBorder: `2px solid ${o}`,
    dotBorderActive: `2px solid ${r}`,
    dotBoxShadow: ""
  });
}, h = {
  name: "Slider",
  common: b,
  self: g
}, S = h;
export {
  S as default
};
